import type * as React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const VehicleCardSkeleton: React.FC = () => {
  return (
    <Card className="min-h-120 w-full gap-0 rounded-3xl border-0 bg-linear-to-t from-slate-500/80 to-slate-900/80 py-0 ring-0">
      <CardHeader className="gap-2.5 p-5 pb-0">
        <div className="flex items-baseline gap-2">
          <Skeleton className="h-5 w-28 bg-slate-400/40" />
          <Skeleton className="h-3.5 w-14 bg-slate-400/40" />
        </div>
        <Skeleton className="h-3.5 w-1/2 bg-slate-400/40" />
        <div className="flex gap-1.5 pt-0.5">
          <Skeleton className="h-6 w-11 rounded-full bg-slate-400/40" />
          <Skeleton className="h-6 w-11 rounded-full bg-slate-400/40" />
          <Skeleton className="h-6 w-12 rounded-full bg-slate-400/40" />
        </div>
      </CardHeader>
      <CardContent className="flex flex-1 flex-col justify-between p-5 pt-3">
        <Skeleton className="h-40 w-full rounded-lg bg-slate-400/40" />
        <div className="mt-4 flex items-baseline justify-between gap-2">
          <Skeleton className="h-7 w-20 bg-slate-400/40" />
          <Skeleton className="h-4 w-24 bg-slate-400/40" />
        </div>
      </CardContent>
    </Card>
  );
};
